import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const InboxLink = ({ title = 'Inbox' }) => {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);
  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
  useEffect(() => {
    if (!user) return undefined;
    let active = true;
    axios.get(`${API}/inbox?limit=0`).then(({ data }) => active && setUnread(Number(data?.unread_count || 0))).catch(() => active && setUnread(0));
    return () => { active = false; };
  }, [API, user]);
  return <Link to="/inbox" className="relative rounded-md p-2 text-slate-500 hover:bg-slate-100" title={title} aria-label="Inbox"><Bell className="h-5 w-5" />{unread > 0 && <span className="absolute -right-1 -top-1 min-w-5 rounded-full bg-teal-600 px-1 text-center text-[10px] font-bold leading-5 text-white">{unread > 99 ? '99+' : unread}</span>}</Link>;
};
export default InboxLink;
